import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';


const authToken = localStorage.getItem('currentUser');
const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Authorization': `${authToken}`
	})
};


@Injectable()
export class ForgotPasswordService {
	apiUrl= environment.url;

	constructor(private http: HttpClient,) { }

	forgotPasswordEmail( body) {
		console.log('In forgotPasswordEmail');
		return this.http.post(this.apiUrl + '/forgot-password', body);

	}

	forgotPasswordReset(body) {
		console.log('In forgotPasswordEmail');
		return this.http.post(this.apiUrl + '/users/change-password', body, http_options);

	}

}





// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/_services/forgot-password.service.ts